export default __webpack_public_path__ + "static/media/block-services-4.2d26648d.webp";